import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { LaunchDarklyFlag, LaunchDarklyService } from '@aiwyn/config';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

/**
 * `canMatch` guard for the redesigned CRL detail page.
 *
 * Two route entries share the request-detail path: this guard gates the new
 * `CxpNewCrlPageComponent` entry, and the legacy `TaskRequestDetailContainerComponent`
 * entry follows it with no guard. When the flag is ON this matches and the new
 * page loads; when OFF (or LD is unreachable) it returns false, the router skips
 * this entry, and the legacy route below matches — so flag-OFF behaviour is
 * byte-for-byte identical to today.
 *
 * Default-safe: `getFeatureFlag` waits for LD to load; any error resolves to
 * false, never trapping the route on a redesign that isn't enabled.
 */
export const cxpNewCrlPageGuard: CanMatchFn = (): Observable<boolean> => {
  const launchDarklyService = inject(LaunchDarklyService);

  return launchDarklyService.getFeatureFlag(LaunchDarklyFlag.CXP_ENABLE_REQUEST_LIST_REDESIGN).pipe(
    take(1),
    map((flagEnabled) => flagEnabled === true),
    catchError(() => of(false)),
  );
};
